var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfArrowLeftPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90002 0.9999C10.0863 1.18726 10.1908 1.44071 10.1908 1.7049C10.1908 1.96909 10.0863 2.22254 9.90002 2.4099L3.32002 8.9999L10 15.6599C10.1863 15.8473 10.2908 16.1007 10.2908 16.3649C10.2908 16.6291 10.1863 16.8825 10 17.0699C9.90706 17.1636 9.79646 17.238 9.6746 17.2888C9.55274 17.3396 9.42204 17.3657 9.29003 17.3657C9.15801 17.3657 9.02731 17.3396 8.90545 17.2888C8.78359 17.238 8.67299 17.1636 8.58002 17.0699L1.19002 9.7099C1.0963 9.61694 1.0219 9.50634 0.971133 9.38448C0.920365 9.26262 0.894226 9.13191 0.894226 8.9999C0.894226 8.86789 0.920365 8.73718 0.971133 8.61532C1.0219 8.49346 1.0963 8.38286 1.19002 8.2899L8.48002 0.9999C8.57299 0.906171 8.68359 0.831777 8.80545 0.781008C8.92731 0.73024 9.05801 0.704102 9.19003 0.704102C9.32204 0.704102 9.45274 0.73024 9.5746 0.781008C9.69646 0.831777 9.80706 0.906171 9.90002 0.9999Z",
    fill: "#767B88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfArrowLeftPage);
export default __webpack_public_path__ + "static/media/pdf_arrow_left_page.77acf28006ee1d87f14520b873237ba9.svg";
export { ForwardRef as ReactComponent };